/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Cloud_Url_LabelInputs */



/**
* | output |
* | --- |
* | "Cloud Storage URL" |
*
* @param {New_Project_Cloud_Url_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_cloud_url_label = /** @type {((inputs?: New_Project_Cloud_Url_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Cloud_Url_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("URL du stockage cloud")
	if (locale === "de") return /** @type {LocalizedString} */ ("Cloud-Speicher-URL")
	if (locale === "it") return /** @type {LocalizedString} */ ("URL di archiviazione cloud")
	if (locale === "ru") return /** @type {LocalizedString} */ ("URL облачного хранилища")
	if (locale === "es") return /** @type {LocalizedString} */ ("URL de almacenamiento en la nube")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("云存储 URL")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クラウドストレージURL")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्लाउड स्टोरेज यूआरएल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("URL de armazenamento em nuvem")
	return /** @type {LocalizedString} */ ("Cloud Storage URL")
});